<template>
  <div class="flex flex-col gap-4 mt-3">
    <div class="flex flex-row">
      <p class="font-bold my-auto">Budget Line Items:</p>
      <InputNumber
        v-model="budgetItemsToAdd"
        showButtons
        :min="1"
        :max="100"
        class="h-10 ml-3"
        inputClass="w-24 pe-0"
        increment-button-class="py-0!"
        decrement-button-class="py-0!"
        :allowEmpty="false"
      ></InputNumber>
    </div>
    <div class="flex flex-row">
      <p class="font-bold my-auto">{{ mode == "CREATE" ? "Automatically Number Line Items:" : "Add To Last Row:" }}</p>
      <Checkbox v-model="modalOption" :binary="true" class="ml-3" />
    </div>
    <div class="flex justify-end">
      <SubmitButton :label="mode" icon="plus" @click="$emit('createItems', budgetItemsToAdd, modalOption)"></SubmitButton>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  mode: "CREATE" | "ADD";
}
const props = defineProps<Props>();

const emit = defineEmits<{
  createItems: [rowsToAdd: number, modalOption: boolean];
}>();

const budgetItemsToAdd = ref(1);
const modalOption = ref(true);
</script>
